// import React, { useState } from 'react';
// import {
//     FaFilePdf,
//     FaFileExcel,
//     FaPrint,
//     FaCloudDownloadAlt
// } from 'react-icons/fa';
// import autoTable, { RowInput } from "jspdf-autotable"; // Import RowInput
// import jsPDF from 'jspdf';
// import * as XLSX from 'xlsx';
// import { MdClose } from 'react-icons/md';

// interface DataItem { 
//     [key: string]: any; 
// }

// const ExportPopup: React.FC<{ data: DataItem[], onClose: () => void }> = ({ onClose, data }) => { // Use the interface here
//     const [selectedOption, setSelectedOption] = useState(null);

//     // Function to process data and remove propertyAddress
//     const processData = (inputData: DataItem[]): DataItem[] => {
//         return inputData.map((item: DataItem) => {
//             const { propertyAddress, ...rest } = item;
//             return rest;
//         });
//     };

//     const handleExportPDF = () => {
//         // Process the data to remove propertyAddress
//         const dataToExport = processData(data);

//         const doc = new jsPDF({ orientation: 'landscape' });
//         const tableColumn = Object.keys(dataToExport[0]);
//         // Explicitly type tableRows as RowInput[]
//         const tableRows: RowInput[] = dataToExport.map((item: DataItem) => Object.values(item));

//         autoTable(doc, {
//           head: [tableColumn],
//           body: tableRows,
//           styles: {
//             halign: 'center',  // Horizontal alignment
//             valign: 'middle',  // Vertical alignment
//             fontSize: 8,      // Smaller font size to fit more content
//             cellPadding: 1,    // Reduced cell padding
//           },
//           columnStyles: {
//             0: { cellWidth: 'auto' }, // Auto-size first column
//             1: { cellWidth: 'auto' }, // Auto-size second column
//             // comments: { 
//             //     cellWidth: 'auto', 
//             //     overflow: 'linebreak', 
//             // },
//             // You can repeat this for each column or set custom widths
//             2: { cellWidth: 'auto' },
//             3: { cellWidth: 'auto' },
//             4: { cellWidth: 'auto' },
//             5: { cellWidth: 'auto' },
//             6: { cellWidth: 'auto' },
//             7: { cellWidth: 'auto' },
//             8: { cellWidth: 'auto' },
//             9: { cellWidth: 'auto' },
            
//             10: { cellWidth: 'auto', 
//                overflow: 'linebreak',},
          
          
//           11: { cellWidth: 'auto' },
//             },
//           headStyles: {
//             fillColor: [22, 160, 133], // Header background color
//             textColor: 255,            // Header text color
//             fontStyle: 'bold',         // Header font style
//             halign: 'center',          // Header alignment
//           },
//           bodyStyles: {
//             halign: 'center', // Body alignment
//           },
//           margin: { top: 5, right: 5, bottom: 5, left: 5 }, // Margins
//           pageBreak: 'auto', // Automatically add page breaks if content overflows
//         });
      
//         doc.save("Payment_Report.pdf");
//       };

//     const handleExportExcel = () => {
//         // Process the data to remove propertyAddress
//         const dataToExport = processData(data);
//         const worksheet = XLSX.utils.json_to_sheet(dataToExport);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
//         XLSX.writeFile(workbook, "Payment_Report.xlsx");
//     };

//     const handlePrint = () => {
//         // Process the data to remove propertyAddress
//         const dataToExport = processData(data);

//         const printWindow = window.open("", "_blank");
//         const tableColumn = Object.keys(dataToExport[0]).join("</th><th>");
//         const tableRows = dataToExport
//             .map((item: DataItem) => `<tr><td>${Object.values(item).join("</td><td>")}</td></tr>`)
//             .join("");

//         printWindow?.document.write(`
//           <html>
//             <head><title>Print Data</title></head>
//             <body>
//               <table border="1">
//                 <thead>
//                   <tr><th>${tableColumn}</th></tr>
//                 </thead>
//                 <tbody>${tableRows}</tbody>
//               </table>
//             </body>
//           </html>
//         `);
//         printWindow?.document.close();
//         printWindow?.print();
//     };

//     const exportOptions = [
//         {
//             icon: <FaFilePdf className="text-3xl text-red-500" />,
//             label: 'Export as PDF',
//             action: handleExportPDF
//         },
//         {
//             icon: <FaFileExcel className="text-3xl text-green-500" />,
//             label: 'Export as Excel',
//             action: handleExportExcel
//         },
//         {
//             icon: <FaPrint className="text-3xl text-blue-500" />,
//             label: 'Print',
//             action: handlePrint
//         }
//     ];

//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white rounded-xl shadow-2xl p-8 w-96 transform transition-all duration-300 ease-in-out">
//                 <div className="flex justify-between items-center mb-6">
//                     <h2 className="text-2xl font-bold text-gray-800 flex items-center">
//                         <FaCloudDownloadAlt className="mr-3 text-indigo-600" />
//                         Export Options
//                     </h2>
//                     <button
//                         className="text-gray-500 hover:text-primary hover:bg-primary/10 rounded-full p-2 transition-colors"
//                         onClick={() => { onClose() }}
//                     >
//                         <MdClose className='h-7 w-7' />
//                     </button>
//                 </div>

//                 <div className="space-y-4">
//                     {exportOptions.map((option, index) => (
//                         <button
//                             key={index}
//                             onClick={option.action}
//                             className="w-full flex items-center justify-start p-4
//                                         bg-gray-100 rounded-lg hover:bg-gray-200
//                                         transition-all duration-300 ease-in-out
//                                         transform hover:scale-105 focus:outline-none"
//                         >
//                             {option.icon}
//                             <span className="ml-4 text-lg font-medium text-gray-700">
//                                 {option.label}
//                             </span>
//                         </button>
//                     ))}
//                 </div>

//                 <div className="mt-6 text-center">
//                     <p className="text-sm text-gray-500">
//                         Choose your preferred export method
//                     </p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ExportPopup;


import React, { useState } from 'react';
import {
    FaFilePdf,
    FaFileExcel,
    FaPrint,
    FaCloudDownloadAlt
} from 'react-icons/fa';
import autoTable, { RowInput } from "jspdf-autotable";
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import { MdClose } from 'react-icons/md';

interface DataItem { 
    [key: string]: any; 
}

interface ExportPopupProps {
  data: DataItem[];
  onClose: () => void;
  filename?: string; // Add filename prop
}

const ExportPopup: React.FC<ExportPopupProps> = ({ onClose, data, filename = "report" }) => {
    const [selectedOption, setSelectedOption] = useState(null);

    // Function to process data and remove propertyAddress
    const processData = (inputData: DataItem[]): DataItem[] => {
        return inputData.map((item: DataItem) => {
            const { propertyAddress, ...rest } = item;
            return rest;
        });
    };

    const handleExportPDF = () => {
        // Process the data to remove propertyAddress
        const dataToExport = processData(data);

        const doc = new jsPDF({ orientation: 'landscape' });
        const tableColumn = Object.keys(dataToExport[0]);
        const tableRows: RowInput[] = dataToExport.map((item: DataItem) => Object.values(item));

        autoTable(doc, {
          head: [tableColumn],
          body: tableRows,
          styles: {
            halign: 'center',
            valign: 'middle',
            fontSize: 8,
            cellPadding: 1,
          },
          columnStyles: {
            0: { cellWidth: 'auto' },
            1: { cellWidth: 'auto' },
            2: { cellWidth: 'auto' },
            3: { cellWidth: 'auto' },
            4: { cellWidth: 'auto' },
            5: { cellWidth: 'auto' },
            6: { cellWidth: 'auto' },
            7: { cellWidth: 'auto' },
            8: { cellWidth: 'auto' },
            9: { cellWidth: 'auto' },
            10: { cellWidth: 'auto', overflow: 'linebreak' },
            11: { cellWidth: 'auto' },
          },
          headStyles: {
            fillColor: [22, 160, 133],
            textColor: 255,
            fontStyle: 'bold',
            halign: 'center',
          },
          bodyStyles: {
            halign: 'center',
          },
          margin: { top: 5, right: 5, bottom: 5, left: 5 },
          pageBreak: 'auto',
        });
      
        doc.save(`${filename}.pdf`); // Use the filename prop
    };

    const handleExportExcel = () => {
        // Process the data to remove propertyAddress
        const dataToExport = processData(data);
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, `${filename}.xlsx`); // Use the filename prop
    };

    const handlePrint = () => {
        // Process the data to remove propertyAddress
        const dataToExport = processData(data);

        const printWindow = window.open("", "_blank");
        const tableColumn = Object.keys(dataToExport[0]).join("</th><th>");
        const tableRows = dataToExport
            .map((item: DataItem) => `<tr><td>${Object.values(item).join("</td><td>")}</td></tr>`)
            .join("");

        printWindow?.document.write(`
          <html>
            <head><title>${filename}</title></head> {/* Use filename in title */}
            <body>
              <h2>${filename.replace('_', ' ').toUpperCase()}</h2>
              <table border="1">
                <thead>
                  <tr><th>${tableColumn}</th></tr>
                </thead>
                <tbody>${tableRows}</tbody>
              </table>
            </body>
          </html>
        `);
        printWindow?.document.close();
        printWindow?.print();
    };

    const exportOptions = [
        {
            icon: <FaFilePdf className="text-3xl text-red-500" />,
            label: 'Export as PDF',
            action: handleExportPDF
        },
        {
            icon: <FaFileExcel className="text-3xl text-green-500" />,
            label: 'Export as Excel',
            action: handleExportExcel
        },
        {
            icon: <FaPrint className="text-3xl text-blue-500" />,
            label: 'Print',
            action: handlePrint
        }
    ];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-2xl p-8 w-96 transform transition-all duration-300 ease-in-out">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                        <FaCloudDownloadAlt className="mr-3 text-indigo-600" />
                        Export Options
                    </h2>
                    <button
                        className="text-gray-500 hover:text-primary hover:bg-primary/10 rounded-full p-2 transition-colors"
                        onClick={onClose}
                    >
                        <MdClose className='h-7 w-7' />
                    </button>
                </div>

                <div className="space-y-4">
                    {exportOptions.map((option, index) => (
                        <button
                            key={index}
                            onClick={option.action}
                            className="w-full flex items-center justify-start p-4
                                        bg-gray-100 rounded-lg hover:bg-gray-200
                                        transition-all duration-300 ease-in-out
                                        transform hover:scale-105 focus:outline-none"
                        >
                            {option.icon}
                            <span className="ml-4 text-lg font-medium text-gray-700">
                                {option.label}
                            </span>
                        </button>
                    ))}
                </div>

                <div className="mt-6 text-center">
                    <p className="text-sm text-gray-500">
                        Choose your preferred export method
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ExportPopup;
